import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-ce-datetime-picker',
  templateUrl: './ce-datetime-picker.component.html',
  styleUrls: ['./ce-datetime-picker.component.css', './timepicker.scss']
})
export class CeDatetimePickerComponent implements OnInit {

  @Input() showPanel: boolean = false;
  @Output() showPanelChange = new EventEmitter<boolean>();
  @Input() date: string;
  @Input() label: string;
  @Output() dateChange = new EventEmitter<Date>();

  day: number = null;
  month: string = null;
  year: number = null;

  hour: number = 12; // Hour in 12-hour format
  minute: number = 0; // Minute
  period: 'AM' | 'PM' = 'AM'; // AM/PM period

  months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];


  ngOnInit(): void {
    this.reset();
  }

  // Days in each month, adjusted for leap years in February
  getDaysInMonth(month: string, year: number): number {
    const monthIndex = this.months.indexOf(month);
    if (monthIndex === 1) { // February
      return this.isLeapYear(year) ? 29 : 28;
    }
    return [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][monthIndex];
  }

  isLeapYear(year: number): boolean {
    return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
  }

  get formattedDate(): string {
    // prepend 0 to hour minute, month, day and second if the value is less than 10
    const formattedHour = this.hour < 10 ? '0' + this.hour : this.hour;
    const formattedMinute = this.minute < 10 ? '0' + this.minute : this.minute;
    const formattedDay = this.day < 10 ? '0' + this.day : this.day;
    return `${this.month} ${formattedDay} ${this.year} ${formattedHour}:${formattedMinute} ${this.period}`;
  }

  addDay(value: number): void {
    this.day += value;
    let daysInCurrentMonth = this.getDaysInMonth(this.month, this.year);
    

    

    if (this.day > daysInCurrentMonth) {
      this.day -= daysInCurrentMonth;
      this.addMonth(1);
    } else if (this.day <= 0) {
      this.addMonth(-1);
      daysInCurrentMonth = this.getDaysInMonth(this.month, this.year);
      this.day = daysInCurrentMonth;
    }

    // add plus one to year if the day is the last day of year
    if (this.day === 1 && this.month === 'January' && value == 1) {
      this.addYear(1);
    } else if (this.day === 31 && this.month === 'December' && value == -1) {
      this.addYear(-1);
    }

    
  }

  addMonth(value: number): void {
    let currentIndex = this.months.indexOf(this.month);
    currentIndex = (currentIndex + value + 12) % 12;

    // Adjust year if month index overflows
    if (currentIndex < 0) {
      this.year -= 1;
      currentIndex += 12;
    } else if (currentIndex >= 12) {
      this.year += 1;
    }

    this.month = this.months[currentIndex];
    const daysInCurrentMonth = this.getDaysInMonth(this.month, this.year);

    // Adjust the day if it exceeds the new month's days
    if (this.day > daysInCurrentMonth) {
      this.day = daysInCurrentMonth;
    }
  }

  addYear(value: number): void {
    this.year += value;
    const daysInCurrentMonth = this.getDaysInMonth(this.month, this.year);

    // Adjust the day if it exceeds the new year's month's days
    if (this.day > daysInCurrentMonth) {
      this.day = daysInCurrentMonth;
    }
  }

  reset(): void {
    let todaysDate = this.date ? new Date(this.date) : new Date();
    this.day = todaysDate.getDate();
    this.month = this.months[todaysDate.getMonth()];
    this.year = todaysDate.getFullYear();
    // get the current hour in 12 hours format
    this.hour = todaysDate.getHours() % 12;
    this.hour = this.hour ? this.hour : 12; // 0 should be converted to 12
    this.minute = 0;
    this.period = todaysDate.getHours() < 12 ? 'AM' : 'PM';
  }

  cancel(): void {
    console.log('Cancel action triggered');
    this.showPanel = false;
    this.showPanelChange.emit(this.showPanel);
  }

  confirm(): void {
    console.log('Confirm action triggered');
    let outputDate: Date = new Date(this.year, this.months.indexOf(this.month), this.day, 
    (this.period === 'AM' ? (this.hour == 12? 0 : this.hour) : (this.hour == 12? this.hour : this.hour + 12)), this.minute);
    
    this.dateChange.emit(outputDate);
  }

   // Increment the hour with wrapping between 1 and 12
   incrementHour(): void {
    if (this.hour === 12) {
      this.hour = 1;
      this.togglePeriod(); // Toggle AM/PM when hour wraps around
    } else {
      this.hour++;
    }
  }

  // Decrement the hour with wrapping between 1 and 12
  decrementHour(): void {
    if (this.hour === 1) {
      this.hour = 12;
      this.togglePeriod(); // Toggle AM/PM when hour wraps around
    } else {
      this.hour--;
    }
  }

  // Increment the minute with wrapping between 0 and 59
  incrementMinute(): void {
    this.minute+=30;
    if (this.minute === 60) {
      this.minute = 0;
      this.incrementHour(); // Increment hour when minute wraps around
    }
  }

  // Decrement the minute with wrapping between 0 and 59
  decrementMinute(): void {
    this.minute-=30;
    if (this.minute < 0) {
      this.minute = 30;
      this.decrementHour(); // Decrement hour when minute wraps around
    }
  }

  // Toggle AM/PM
  togglePeriod(): void {
    this.period = this.period === 'AM' ? 'PM':'AM';
}



}
